export default function Connect (props) {

    return (
        <svg stroke={props.stroke || 'transparent'} fill={props.fill || '#000'} className={props.className} style={props.style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 12">
            <path d="M 10 0 L 6 0 C -2 0 -2 12 6 12 L 10 12 L 10 10 L 6 10 C 1 10 1 2 6 2 L 10 2 M 14 2 L 18 2 C 23 2 23 10 18 10 L 14 10 L 14 12 L 18 12 C 26 12 26 0 18 0 L 14 0 M 8 5 L 16 5 L 16 7 L 8 7" fill="#000000"/>
        </svg>
    )

}